function Logo(props) {
  Logo.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="36"
      //fill="none"
      viewBox="0 0 200 36"
    >
      <path
        fill={props.fill}
        d="M19.218 15.683c2.822 1 4.572 3.144 4.572 6.18 0 4.323-3.572 6.86-10.287 6.86H0V3.715h12.788c6.573 0 9.788 2.68 9.788 6.538 0 2.394-1.215 4.323-3.358 5.43zm-7.359-6.859H7.001v4.823h4.858c2.358 0 3.572-.822 3.572-2.43 0-1.571-1.214-2.393-3.572-2.393zm1.072 14.79c2.429 0 3.715-.822 3.715-2.536 0-1.715-1.286-2.537-3.715-2.537h-5.93v5.073h5.93zM30.526 7.216c-2.5 0-4.144-1.571-4.144-3.608C26.382 1.572 28.025 0 30.525 0c2.501 0 4.144 1.465 4.144 3.501 0 2.144-1.643 3.715-4.143 3.715zm-3.394 21.507V9.36h6.787v19.363h-6.787zm18.735.321c-4.68 0-7.537-2.465-7.537-7.109V2.215h6.787v19.363c0 1.465.786 2.215 2.107 2.215.572 0 1.179-.179 1.536-.357l.286 5.108a9.999 9.999 0 01-3.18.5zm13.151 0c-4.68 0-7.537-2.465-7.537-7.109V2.215h6.787v19.363c0 1.465.786 2.215 2.107 2.215.572 0 1.18-.179 1.536-.357l.286 5.108a9.998 9.998 0 01-3.179.5zm18.402.179c-7.93 0-13.753-5.395-13.753-13.004 0-7.61 5.823-13.004 13.753-13.004 4.608 0 8.323 1.68 10.752 4.716l-4.5 4.073c-1.572-1.894-3.501-2.93-5.895-2.93-4.108 0-6.965 2.858-6.965 7.145 0 4.287 2.857 7.145 6.965 7.145 2.394 0 4.323-1.036 5.894-2.93l4.501 4.073c-2.429 3.037-6.144 4.716-10.752 4.716zm26.194-20.185c4.536 0 8.001 2.608 8.001 8.61v11.075h-6.787v-9.967c0-2.787-1.214-3.966-3.179-3.966-2.18 0-3.858 1.358-3.858 4.573v9.36h-6.787V2.215h6.787v8.931c1.5-1.393 3.536-2.108 5.823-2.108zm26.222.322h6.787v19.363h-6.465v-1.93c-1.286 1.537-3.179 2.251-5.715 2.251-5.251 0-9.502-3.858-9.502-10.038 0-6.145 4.251-9.968 9.502-9.968 2.25 0 4.072.643 5.393 2.001v-1.68zm-3.965 14.29c2.287 0 4.073-1.68 4.073-4.644 0-2.93-1.786-4.573-4.073-4.573-2.286 0-4.072 1.643-4.072 4.573 0 2.965 1.786 4.644 4.072 4.644zm40.34-14.612c4.501 0 7.823 2.608 7.823 8.61v11.075h-6.787v-9.967c0-2.787-1.143-3.966-2.929-3.966-1.965 0-3.394 1.322-3.394 4.323v9.61h-6.787v-9.967c0-2.787-1.107-3.966-2.929-3.966-2 0-3.429 1.322-3.429 4.323v9.61h-6.787V9.36h6.465v2.036c1.465-1.572 3.501-2.358 5.787-2.358 2.644 0 4.894.965 6.251 3.037 1.536-1.93 3.93-3.037 6.716-3.037zm24.287 0c5.251 0 9.502 3.859 9.502 10.003 0 6.145-4.251 10.003-9.502 10.003-2.25 0-4.072-.678-5.394-2.036v8.645h-6.787V9.36h6.466v1.929c1.286-1.536 3.179-2.25 5.715-2.25zm-1.429 14.612c2.287 0 4.073-1.68 4.073-4.609 0-2.93-1.786-4.608-4.073-4.608-2.286 0-4.072 1.679-4.072 4.608 0 2.93 1.786 4.609 4.072 4.609z"
      ></path>
    </svg>
  );
}

function RestaurantIcon(props) {
  RestaurantIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="26"
      fill="none"
      viewBox="0 0 27 26"
    >
      <path
        stroke="#343F52"
        strokeLinejoin="round"
        d="M2.422 1.378l20.56 20.56a2.08 2.08 0 01-2.942 2.943l-5.022-5.11a1.786 1.786 0 01-.514-1.251v-.309a1.785 1.785 0 00-.53-1.27l-.65-.6a1.785 1.785 0 00-1.662-.415 2.707 2.707 0 01-2.599-.705l-4.767-4.768C1.468 7.625.427 3.354 2.422 1.378z"
      ></path>
      <path
        stroke="#3F78E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.536.5l-4.311 4.31a3.573 3.573 0 00-1.047 2.527v.829a.893.893 0 01-.261.632l-.631.63m1.785 1.786l.631-.63a.892.892 0 01.632-.262h.83a3.572 3.572 0 002.525-1.047L26 4.965m-2.232-2.233l-4.465 4.465M10.375 19.25L4.81 24.846a2.232 2.232 0 01-3.156-3.156l4.703-4.672"
      ></path>
    </svg>
  );
}
function BarsBreweriesIcon(props) {
  BarsBreweriesIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="29"
      fill="none"
      viewBox="0 0 26 29"
    >
      <path
        fill="#343F52"
        fillRule="evenodd"
        d="M0 5h21.239v1.032l-1.89 1.575c-2.264 1.886-4.328 4.528-5.825 7.288-1.501 2.767-2.404 5.602-2.404 7.868v4.857h5.452v1H4.667v-1h5.453v-4.857c0-2.267-.904-5.1-2.405-7.868-1.497-2.76-3.561-5.402-5.824-7.288L0 6.032V5zm10.62 14.356c.436-1.614 1.138-3.302 2.025-4.938a28.606 28.606 0 012.363-3.656H6.23a28.616 28.616 0 012.363 3.656c.887 1.636 1.59 3.324 2.026 4.938zM5.434 9.762h10.372a23.197 23.197 0 012.902-2.923L19.715 6H1.525l1.006.839c1.02.85 1.997 1.842 2.903 2.923z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#3F78E0"
        fillRule="evenodd"
        d="M21.293.206A5.857 5.857 0 0014 4.762h1.022a4.858 4.858 0 114.733 5.953v1A5.857 5.857 0 0021.293.205z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
function FineDiningIcon(props) {
  FineDiningIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="24"
      fill="none"
      viewBox="0 0 27 24"
    >
      <path
        stroke="#3F78E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 4.308a12.5 12.5 0 0112.5 12.5 1.923 1.923 0 01-1.923 1.923H2.923A1.923 1.923 0 011 16.808a12.5 12.5 0 0112.5-12.5zm0 0V1.423"
      ></path>
      <path
        stroke="#343F52"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 22.577h25"
      ></path>
    </svg>
  );
}
function BakeriesIcon(props) {
  BakeriesIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="26"
      fill="none"
      viewBox="0 0 27 26"
    >
      <path
        stroke="#343F52"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.173 10.596H25.04m-7.52-9.577l-.173-.038-15.865 9.346a.904.904 0 00-.481.75V23.98a.961.961 0 00.962.961h23.076a.962.962 0 00.962-.961V10.519a11.308 11.308 0 00-8.48-9.5z"
      ></path>
      <path
        stroke="#343F52"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 19.577l.154-.135a3.845 3.845 0 012.73-1.154 3.846 3.846 0 013.847 3.846 3.846 3.846 0 01-1.135 2.712l-.154.173"
      ></path>
      <path
        fill="#3F78E0"
        d="M15.196 19.233a2.098 2.098 0 10-4.196 0 2.098 2.098 0 004.196 0zM23.238 15.211c0-1.062-.94-1.923-2.098-1.923-1.159 0-2.098.861-2.098 1.923 0 1.063.94 1.924 2.098 1.924 1.159 0 2.098-.861 2.098-1.924z"
      ></path>
    </svg>
  );
}
function CafeIcon(props) {
  CafeIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        fill="#343F52"
        d="M25 12v.914a4.088 4.088 0 01-1.22 2.91 4.194 4.194 0 01-2.947 1.205h-.047a10.588 10.588 0 01-4.139 5.485h4.186c.123 0 .24.049.328.134a.454.454 0 010 .647.466.466 0 01-.328.134H.463a.466.466 0 01-.327-.134.454.454 0 010-.647.466.466 0 01.327-.134h4.186a10.6 10.6 0 01-3.41-3.776A10.448 10.448 0 010 13.828V8.344c0-.121.049-.238.136-.323a.466.466 0 01.327-.134h20.37c1.105 0 2.165.433 2.947 1.205A4.088 4.088 0 0125 12zm-4.63 1.829V8.8H.926v5.029a9.544 9.544 0 001.517 5.14 9.716 9.716 0 004.063 3.545h8.284a9.716 9.716 0 004.063-3.546 9.544 9.544 0 001.517-5.14zM24.074 12c0-.77-.28-1.513-.791-2.095a3.253 3.253 0 00-1.987-1.072v4.996c0 .766-.085 1.53-.254 2.279a3.258 3.258 0 002.155-1.005 3.179 3.179 0 00.877-2.189V12z"
      ></path>
      <path
        fill="#3F78E0"
        d="M6.481 1.029v3.657c0 .12.05.237.136.323a.466.466 0 00.655 0 .454.454 0 00.135-.323V1.029a.454.454 0 00-.135-.324.466.466 0 00-.655 0 .454.454 0 00-.136.324zM10.976 5.009a.466.466 0 01-.655 0 .454.454 0 01-.136-.323V1.029c0-.122.049-.238.136-.324a.466.466 0 01.655 0 .454.454 0 01.135.324v3.657a.454.454 0 01-.136.323zM14.68 5.009a.466.466 0 01-.655 0 .454.454 0 01-.136-.323V1.029c0-.122.049-.238.136-.324a.466.466 0 01.79.324v3.657a.454.454 0 01-.136.323z"
      ></path>
    </svg>
  );
}
function FastFoodIcon(props) {
  FastFoodIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="26"
      fill="none"
      viewBox="0 0 29 26"
    >
      <path
        stroke="#343F52"
        strokeMiterlimit="10"
        d="M5.93 3.326C4.7 6.333 4.17 9.488 4.17 12.969c0 3.48.585 6.877 1.736 9.652.214.523.585.989 1.268.652.555-.273 15.148-6.869 20.352-9.375a1.037 1.037 0 00.587-.93 1.03 1.03 0 00-.587-.932L7.212 2.7c-.449-.207-1.002-.059-1.281.627z"
      ></path>
      <path
        stroke="#343F52"
        strokeMiterlimit="10"
        d="M3.279 1.257C1.925 4.647 1 8.822 1 13s.84 8.291 2.24 11.753c.126.305.417.877.906.72l1.585-.63c.54-.26.54-.564.54-.98 0-.117-.067-.28-.144-.474A28.571 28.571 0 014.154 13c0-3.695.789-7.481 1.972-10.39.092-.234.143-.364.143-.475 0-.428.144-.675-.532-.976L4.154.523c-.394-.131-.71.325-.875.734z"
      ></path>
      <path
        fill="#3F78E0"
        d="M12.62 17.05a2.113 2.113 0 10-4.226 0 2.113 2.113 0 004.226 0zM13.676 8.95a2.113 2.113 0 10-4.225 0 2.113 2.113 0 004.225 0zM20.718 13c0-1.07-.946-1.937-2.113-1.937-1.166 0-2.112.867-2.112 1.937s.946 1.937 2.112 1.937c1.167 0 2.113-.867 2.113-1.937z"
      ></path>
    </svg>
  );
}
function LargeChainRestaurantsIcon(props) {
  LargeChainRestaurantsIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="26"
      fill="none"
      viewBox="0 0 23 26"
    >
      <path
        fill="#343F52"
        fillRule="evenodd"
        d="M7.031 2.017C8.165 1.115 9.647.5 11.263.5s3.098.615 4.232 1.517c.941.748 1.673 1.718 2.037 2.747a4.168 4.168 0 012.66 7.832V25.5H2.334V12.594a4.167 4.167 0 012.66-7.828c.363-1.03 1.095-2 2.037-2.75zm.74.931c-.957.762-1.595 1.749-1.782 2.67l-.138.681-.651-.24a2.977 2.977 0 00-2.064 5.585l.389.144v7.76h15.476v-7.762l.392-.143a2.975 2.975 0 001.163-4.822 2.978 2.978 0 00-3.227-.764l-.654.245-.138-.684c-.187-.921-.825-1.908-1.783-2.67-.952-.757-2.178-1.258-3.49-1.258-1.314 0-2.54.501-3.492 1.258zm11.23 17.79H3.525v3.572h15.476v-3.572z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#3F78E0"
        fillRule="evenodd"
        d="M7.143 19.548v-7.143h1.19v7.143h-1.19zM10.714 19.548V8.833h1.19v10.715h-1.19zM14.286 19.548v-7.143h1.19v7.143h-1.19z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
function FoodCourtsIcon(props) {
  FoodCourtsIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="14"
      fill="none"
      viewBox="0 0 25 14"
    >
      <path
        fill="#343F52"
        fillRule="evenodd"
        d="M14.611.128H0v3.436L.893.886H13.72l.893 2.678V.128zm1.474 8.292v3.22h3.408a2.734 2.734 0 012.531-1.731c1.099 0 2.047.663 2.476 1.602V9.068l-2.602-.648h-5.813zm5.874-.5L25 8.677v3.463h-.812a2.237 2.237 0 00-2.164-1.731c-1.05 0-1.937.746-2.164 1.731h-4.275V1.957l3.723.714.373.812h-3.338V7.92h5.616zm-3.68-4.937h-2.194v-.42l2.194.42zM14.11 9.285H.5v1.082l1.932 1.273h.286A2.73 2.73 0 015.25 9.91c1.148 0 2.132.724 2.53 1.731h6.33V9.285zm.5-4.828h-.757v4.328H.757V4.457H0v6.179l2.282 1.504h.803a2.231 2.231 0 012.166-1.731c1.05 0 1.937.746 2.164 1.731h7.196V4.457zm2.706 2.489V4.457h2.673l1.244 2.489h-3.917zm3.108-.5l-.744-1.489h-1.864v1.489h2.608zM3.842 6.35h-.866l-.866-.866h2.6l-.868.866zM1.677 7.92v-.974h11.257v.974H1.677zm3.574 3.963a.74.74 0 00-.75.744c0 .415.327.744.75.744a.738.738 0 00.745-.744.738.738 0 00-.745-.744zm16.773 0a.738.738 0 00-.744.744c0 .416.328.744.744.744a.738.738 0 00.745-.744.738.738 0 00-.745-.744zm-18.023.744c0-.693.552-1.244 1.25-1.244.693 0 1.245.552 1.245 1.244 0 .693-.552 1.244-1.245 1.244-.698 0-1.25-.551-1.25-1.244zm16.779 0c0-.693.552-1.244 1.244-1.244.693 0 1.245.552 1.245 1.244 0 .693-.552 1.244-1.245 1.244a1.238 1.238 0 01-1.244-1.244z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#3F78E0"
        d="M1 3.06l.542-1.623H3.98L3.438 3.06H1zM4.461 3.06l.541-1.623h1.764V3.06H4.461zM7.74 3.06V1.437h1.764l.541 1.623H7.74zM11.062 3.06l-.54-1.623h2.44l.54 1.623h-2.44z"
      ></path>
    </svg>
  );
}
function TermsIcon(props) {
  TermsIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 15 15"
    >
      <path
        fill="#C52031"
        d="M7.164 5.472a1.69 1.69 0 00-1.692 1.692 1.69 1.69 0 001.692 1.692 1.69 1.69 0 001.692-1.692 1.69 1.69 0 00-1.692-1.692z"
      ></path>
      <path
        fill="#2F66D4"
        d="M7.164 0C3.222 0 0 3.204 0 7.164c0 3.96 3.222 7.164 7.164 7.164 3.942 0 7.164-3.222 7.164-7.164C14.328 3.222 11.106 0 7.164 0zm0 12.402a5.243 5.243 0 01-5.238-5.238 5.243 5.243 0 015.238-5.238c2.88 0 5.238 2.358 5.238 5.238 0 2.88-2.358 5.238-5.238 5.238z"
      ></path>
    </svg>
  );
}

function BlogIcon(props) {
  TermsIcon.defaultProps = {
    fill: "#343F52", // Replace with your desired default fill color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#343F52"
        d="M9.52 0A.507.507 0 009 .51v1.98c0 .28.22.5.5.5v.02c6.23.24 11.24 5.25 11.48 11.48H21c0 .28.22.5.5.5h1.98c.29 0 .52-.24.51-.52C23.72 6.61 17.38.27 9.52 0zm0 5a.514.514 0 00-.52.51v1.98c0 .28.22.5.5.5v.03c3.47.23 6.24 3 6.47 6.47H16c0 .28.22.5.5.5h1.98c.28 0 .52-.24.51-.52-.27-5.1-4.37-9.2-9.47-9.47zM.5 5.99c-.28 0-.5.22-.5.5v11c0 3.58 2.92 6.5 6.5 6.5s6.5-2.92 6.5-6.5-2.92-6.5-6.5-6.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5a2.5 2.5 0 11-2.5 2.5v-11c0-.28-.22-.5-.5-.5h-3z"
      ></path>
    </svg>
  );
}

export {
  Logo,
  RestaurantIcon,
  BarsBreweriesIcon,
  FineDiningIcon,
  BakeriesIcon,
  CafeIcon,
  FastFoodIcon,
  LargeChainRestaurantsIcon,
  FoodCourtsIcon,
  TermsIcon,
  BlogIcon,
};
